import { ColDef, ColGroupDef } from "@ag-grid-community/all-modules";
import { useEffect, useState } from "react";

export default function useColumnDefinitions(builder: () => (ColDef | ColGroupDef)[], deps?: React.DependencyList) {
    const [cols, setCols] = useState<(ColDef | ColGroupDef)[]>(builder);
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO probably should deprecate this helper; and use memos with proper deps instead
    useEffect(() => setCols(builder()), deps ?? []);
    return cols;
}